import { Company } from '../../../core/company/company.model';

/**
 * Company state interface
 */
export interface CompanyState {
    /**
     * Current Authenticated Company
     */
    current?: Company;
    /**
     * Company api errors that have occurred during user session.
     */
    errors?: Array<any>;
}

/**
 * Initial company state
 */
export const initialCompanyState: CompanyState = {
    current: null,
    errors: [],
};
